import styled from 'styled-components';
import { ArrowRight, AlertCircle } from 'react-feather';
import { RowBetween } from '../../../components/Row';
import { Trans, t } from '@lingui/macro';


const Wrapper = styled.div`
  padding: 1em;
  max-width: ${ ({ maxWidth }) => maxWidth ?? '480px' };
  width: 100%;
  border-radius: 12px;
  background-repeat: repeat;
  background-color: ${ ({ theme }) => theme.bg0 };
  margin-left: auto;
  margin-right: auto;
  cursor: pointer;
`;
const Span = styled.span`
 color: ${ ({ theme }) => theme.warning };
`;


const IconWrapper = styled.div`
  color: ${ ({ theme }) => theme.warning };
`;

function LockPromote({info}) {
  return (
    <Wrapper>
      <RowBetween>
        <div>
          <IconWrapper>
            <AlertCircle />
          </IconWrapper>
          <div>
            <Trans>Locked Days:<Span>{info && info.pledgedays} DAY</Span>  Release Interval Days:<Span>{info && info.gapdays} DAY</Span> </Trans>
          </div>
{/*           <div>
            <Trans> {'Initial Release Ratio(%):'}{info.startprenum}</Trans>
          </div> */}

        </div>


      </RowBetween>


    </Wrapper>
  );
}

export default LockPromote;
